import { userService } from '../../_services';
import router from '../../router/index';
import menu from './menu'
import {parseJwtPayload} from '../../_helpers/auth-header'
import { getLoginPage } from '../../_helpers/auth-header';
import { getUserInfoByLocalStorage } from '../../_helpers/auth-header';
import { invalidateBrRuntimeCache, seedKybAccessGateFromLogin, resetBrReminderDismissedOnLogin } from '../../constants/businessRegistration';


const user = getUserInfoByLocalStorage();
const initialState = user
    ? { status: { loggedIn: true }, 
        user: SetJWTPayLoad(user)}
    : { status: {}, user: null };

function CheckJWTTokenExists(){
    var user = getUserInfoByLocalStorage();
    if(user && user.token)
    {
        return true;
    }
    else{
        return false;
    }
}

function SetJWTPayLoad(userstate){
    // 如果 token 不存在或者是测试 token，直接使用 userstate 中的数据
    if (!userstate || !userstate.token || userstate.token.startsWith('test-token-')) {
        // 测试模式：直接使用 userstate 中的数据，不解析 JWT
        userstate.IsFullAccess = userstate.Permissions?.includes("9991"); // 9991 = code of full access
        return userstate;
    }
    
    // 真实 JWT token 解析
    var JWTtoken = userstate.token;
    var JWTPayload = parseJwtPayload(JWTtoken);
    
    // 检查解析结果
    if (!JWTPayload) {
        // 如果解析失败，使用 userstate 中的原始数据
        userstate.IsFullAccess = userstate.Permissions?.includes("9991");
        return userstate;
    }
    
    //There are two plans: 
    //A: Get all the user info directly from jwt payload 
    //B: Overwrite neccessary user info to localstorage <-- now using this
    //Overwrite
    // 优先保留后端返回的 empCompanyId，只有当它不存在时才使用 JWT payload 的 sub
    // 这样可以避免 newLogin 覆盖旧 login 设置的 CompanyID
    userstate.empCompanyId = userstate.empCompanyId || JWTPayload.sub;
    userstate.userType = JWTPayload.role || userstate.userType;
    userstate.Permissions = JWTPayload.Permissions?.split(",") || userstate.Permissions;
    userstate.IsFullAccess = userstate.Permissions?.includes("9991"); // 9991 = code of full access

    return userstate;

}

export const authentication = {
    namespaced: true,
    state: initialState,
    getters: {
        HasRouteAccessTo: (state) => (RequiredAccessIDs, RequiredAccessRoles) =>{
            
            const UserRole = state?.user?.userType;
            const Permssions = state?.user?.Permissions;

            if(!RequiredAccessIDs && !RequiredAccessRoles){
                // If Access right is not sepcified, go ahead
                return true
            }
            if(!Permssions || !UserRole){
                // If Roles and Permssions object is not found in jwt, deny access
                return false;
            }

            return Permssions?.some(item => RequiredAccessIDs.includes(item))
             || RequiredAccessRoles?.some(item => item.includes(UserRole))
        }
    },
    actions: {
        /**
         * 登录 Action
         * 
         * ⚠️ 接口调用说明：
         * - 此方法调用 userService.login() 进行实际登录
         * - userService.login() 会根据 USE_MOCK_SERVICE 配置选择使用 Mock 或真实接口
         * - 切换到真实接口：修改 Production/src/_services/user.service.js 中的 USE_MOCK_SERVICE = false
         * - 详细说明请参考：Production/src/_services/API_INTEGRATION_GUIDE.md
         */
        login({ dispatch, commit }, { username, passwordjwt,typename,lot_number,captcha_output,pass_token,gen_time, query }) {
            return new Promise((resolve, reject) => {
                commit('loginRequest', { username });
                // 调用 userService，现在 login 内部使用 newLogin 接口
                // 返回格式为 { isSuccessful: true, statusCode: 200, data: {...} }
                userService.login(username, passwordjwt,typename,lot_number,captcha_output,pass_token,gen_time)
                    .then(
                        user => {
                            // 现在 login 使用 newLogin，返回格式与 newLogin 一致
                            if(user && user.statusCode == 200 && user.isSuccessful && user.data)
                                commit('loginSuccess', user.data); 

                            resolve(user);
                        },
                        error => {
                            commit('loginFailure', error);
                            dispatch('alert/error', error, { root: true });
                            // 返回错误对象，格式与 newLogin 一致
                            resolve({
                                isSuccessful: false,
                                statusCode: error?.response?.status || 500,
                                message: error?.message || '登录失败',
                                data: null
                            });
                        }
                    );
            });
           
        },
        logout({ commit }) {
            userService.logout();
            commit('logout');
            if (router.currentRoute.path !== '/auth/login') {
                router.replace('/auth/login').catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation error:', err);
                    }
                });
            }
        },
        
        /**
         * 检查用户账户信息
         * 如果 GetUserMyAccount 接口没有返回数据，则退出登录
         * [22060413 WHS]不要用GetUserMyAccount接口，使用簡單接口
         * 使用GetUserMyAccount_Verify接口，如果沒有返回數據，則退出登錄
         */
        async checkUserAccount({ dispatch }) {
            try {
                const res = await userService.GetUserMyAccount_Verify();
                // 检查接口是否成功返回数据
                if (!res || !res.isSuccessful || !res.data) {
                    // 如果没有返回数据，退出登录
                    console.error('CheckUserAccount No Result:', res);
                    dispatch('logout');
                    return false;
                }

                // 将 accountUserId 写回登录态（Vuex + localStorage），供菜单/用户设置等页面使用
                const accountUserId =
                    res.data.accountUserId ||
                    res.data.AccountUserId ||
                    res.data.accountUserid ||
                    res.data.AccountUserid ||
                    res.data.accountId ||
                    res.data.AccountId ||
                    null;

                if (accountUserId) {
                    dispatch('setUserFields', { accountUserId: parseInt(accountUserId) });
                }
                else{
                    //if accountUserId is not found, logout
                    console.error('CheckUserAccount No AccountUserId:', res.data);
                    dispatch('logout');
                    return false;
                }
                return true;
            } catch (error) {
                console.error('CheckUserAccount error:', error);
                // 接口调用失败，退出登录
                //dispatch('logout');
                return false;
            }
        },
        async redirectToHomeIfLogin({dispatch,commit})
        {
            if(!CheckJWTTokenExists())
            {
                return;
            }
            const res = await userService.GetUserMyAccount();
            if(res && res.isSuccessful && res.data)
            {
                var user = res.data;
                if(user.userRole == "ADMIN")
                {
                    menu.mutations.loginAsAdmin(menu.state);
                    router.push({
                        path: '/Management/supplier',
                    }).catch(() => {});
                }
                else{
                    // KYB 锁定改道时 Vue Router 会 reject，忽略即可
                    router.push({
                        path: '/dashboard/default',
                    }).catch(() => {});
                }
            }
        },
        /**
         * 合并更新当前登录用户字段（同时同步 localStorage.user）
         */
        setUserFields({ commit, state }, fields) {
            const current = state.user || {}; 
            const merged = { ...current, ...(fields || {}) };
            try {
                localStorage.setItem('user', JSON.stringify(merged));
            } catch (e) {
                // ignore
            }
            commit('setUserFields', fields);
        },
        loginByToken({ dispatch, commit }, { token, query }) {
            commit('loginRequest', { token });
            userService.loginUsingToken(token)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        if (user.userType == "ADMIN") {
                            menu.mutations.loginAsAdmin(menu.state);
                            router.push({
                                path: '/Management/supplier',
                                query: query
                            }).catch(() => {});
                        } else {
                            if(query.page){
                                router.push({
                                    path: `/${query.page}/default`,
                                    query: query
                                }).catch(() => {});
                            }   
                            else{
                                router.push({
                                    path: '/',
                                    query: query
                                }).catch(() => {}); 
                            }
                        }
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        }
    },
    mutations: {
        redirectToHomeIfLogin(state) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginRequest(state) {
            state.status = { loggingIn: true };
            state.user =  user; 
        },
        loginSuccess(state, user) {
            invalidateBrRuntimeCache();
            // 每次登录重新弹：过渡期提醒；临期改为「每天一次」不在此重置
            resetBrReminderDismissedOnLogin();
            state.status = { loggedIn: true };
            state.user = user // set the user data from login first
            state.user = SetJWTPayLoad(user)       // then overwrite access right data
            // 登录响应附带的 AccessGate 写回缓存（须在 invalidate 之后）
            seedKybAccessGateFromLogin(user);
        },
        setUserFields(state, fields) {
            if (!state.user) state.user = {};
            state.user = { ...state.user, ...(fields || {}) };
        },
        loginFailure(state) {
            invalidateBrRuntimeCache();
            resetBrReminderDismissedOnLogin();
            state.status = {};
            state.user = null;
        },
        logout(state) {
            invalidateBrRuntimeCache();
            resetBrReminderDismissedOnLogin();
            state.status = {};
            state.user = null;
        }

    }
    
};

